<template>
  <material-card
    scrollable
    :title="
      $t(
        'components.plancreationwizard.billing_and_premiums_reports_display_settings'
      )
    "
    :color="$vuetify.theme.themes.light.secondary"
    icon="assignment"
  >
    <v-form ref="form" v-model="valid" :disabled="disabled">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-row no-gutters>
                  <v-col>
                    <v-checkbox
                      style="display: inline-block"
                      v-model="
                        reportConfiguration.ReportConfiguration
                          .IndividualTaxColumnsInDetailedMembers
                      "
                      :label="
                        $t(
                          'components.plancreationwizard.display_separate_tax_column_per_coverage_in_detailed_members_reports'
                        )
                      "
                    ></v-checkbox>
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      style="
                        margin-bottom: 20px;
                        margin-left: 3px;
                        display: inline-block;
                      "
                    >
                      help
                    </v-icon>
                  </v-col>
                </v-row>
              </template>
              <span>
                {{
                  $t(
                    "components.plancreationwizard.display_separate_tax_column_tooltip"
                  )
                }}
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="
                reportConfiguration.ReportConfiguration.BillingSummaryPerGroup
              "
              :label="
                $t(
                  'components.plancreationwizard.display_billing_summary_per_group_reports'
                )
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="reportConfiguration.ReportConfiguration.ShowSinCert"
              :label="
                $t(
                  'components.plancreationwizard.display_sincert_column_in_detailed_members_reports'
                )
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="reportConfiguration.ReportConfiguration.ShowFamilyStatus"
              :label="
                $t(
                  'components.plancreationwizard.display_family_status_column_in_detailed_members_reports'
                )
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="
                reportConfiguration.ReportConfiguration.HideAdministrationFees
              "
              :label="
                $t('components.plancreationwizard.hide_administration_fees')
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="reportConfiguration.ReportConfiguration.HideEarnings"
              :label="$t('components.plancreationwizard.hide_earnings')"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            v-if="
              hasBilling &&
              !reportConfiguration.ReportConfiguration.HideEarnings
            "
          >
            <div
              style="
                display: inline-block;
                font-size: 16px;
                margin-right: 20px;
                color: rgba(0, 0, 0, 0.6);
              "
            >
              {{
                $t(
                  "components.plancreationwizard.display_selected_employemnt_frequency_in_detailed_member_reports"
                )
              }}
            </div>
            <trans-select
              style="display: inline-block"
              :item="reportConfiguration.ReportConfiguration"
              propertyName="ReportEarningFrequency"
              :items="options.Models.EmploymentFrequency"
              :label="$t('headers.members_management.Employment Frequency')"
              :rules="[$rules.required]"
              class="required"
            ></trans-select>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="
                reportConfiguration.ReportConfiguration
                  .ShowTaxableBenefitsMonthly
              "
              :label="
                $t(
                  'components.plancreationwizard.show_taxable_benefits_on_a_monthly_basis_in_billing_report'
                )
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="reportConfiguration.ReportConfiguration.RemitAdminTax"
              :label="
                $t(
                  'components.plancreationwizard.remit_all_operating_and_admin_fee_taxes_to_the_insurer'
                )
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="
                reportConfiguration.ReportConfiguration
                  .IncorporateCommissionFees
              "
              :label="
                $t('components.plancreationwizard.incorporate_commission_fees')
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="reportConfiguration.ReportConfiguration.ShowRates"
              :label="$t('components.plancreationwizard.show_rates')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="
                reportConfiguration.ReportConfiguration.ShowEmploymentType
              "
              :label="$t('components.plancreationwizard.show_employment_type')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <trans-enum
              :value.sync="reportConfiguration.BillingReportType"
              :items="options.Enums.BillingReportType"
              :label="$t('components.plancreationwizard.billing_report_type')"
              :rules="[$rules.required]"
              class="required"
            ></trans-enum>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </material-card>
</template>
<script>
import TransSelect from "@/components/TransSelect";
import { mapGetters } from "vuex";

export default {
  components: { TransSelect },
  props: ["reportConfiguration", "hasBilling", "disabled"],
  data() {
    return {
      valid: false,
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    valid: {
      handler(v) {
        this.$emit("valid", v);
      },
    },
    reportConfiguration: {
      handler() {
        this.init();
      },
    },
    // hasBilling: {
    //   handler(v) {
    //     if (!v) {
    //       delete this.reportConfiguration.ReportConfiguration;
    //     }
    //   },
    // },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (
        this.reportConfiguration &&
        this.reportConfiguration.ReportConfiguration.ReportEarningFrequency &&
        !this.reportConfiguration.ReportConfiguration.ReportEarningFrequency.Id
      ) {
        this.reportConfiguration.ReportConfiguration.ReportEarningFrequency =
          this.options.Models.EmploymentFrequency.filter(
            (o) =>
              o.Name ===
              this.reportConfiguration.ReportConfiguration
                .ReportEarningFrequency
          )[0];
      }
    },
  },
};
</script>
